// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isSameHour as fn } from "../isSameHour.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isSameHour = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isSameHour;
